import { render, staticRenderFns } from "./CrudErrors.vue?vue&type=template&id=cbd5516c&"
import script from "./CrudErrors.vue?vue&type=script&lang=js&"
export * from "./CrudErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports